// extracted by mini-css-extract-plugin
export default {"imageSize":"About_imageSize__ay1sd","topImage":"About_topImage__l9tQT","heightDivImages":"About_heightDivImages__VaTaO","rotateY":"About_rotateY__qlXxJ","w90":"About_w90__-XFnx"};